export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4774.b961ae32.jpg";